var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStorage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M800,125H125V800a75,75,0,0,0,75,75H875V200A75,75,0,0,0,800,125Zm0,625a50,50,0,0,1-50,50H250a50,50,0,0,1-50-50V575a50,50,0,0,1,50-50H750a50,50,0,0,1,50,50V750Zm0-325a50,50,0,0,1-50,50H250a50,50,0,0,1-50-50V250a50,50,0,0,1,50-50H750a50,50,0,0,1,50,50V425ZM750,225H250a25.028,25.028,0,0,0-25,25V425a25.028,25.028,0,0,0,25,25H750a25.028,25.028,0,0,0,25-25V250A25.028,25.028,0,0,0,750,225ZM575,350a25,25,0,0,1-25,25H450a25,25,0,0,1-25-25V325a25,25,0,0,1,25-25H550a25,25,0,0,1,25,25v25ZM750,550H250a25.028,25.028,0,0,0-25,25V750a25.028,25.028,0,0,0,25,25H750a25.028,25.028,0,0,0,25-25V575A25.028,25.028,0,0,0,750,550ZM575,675a25,25,0,0,1-25,25H450a25,25,0,0,1-25-25V650a25,25,0,0,1,25-25H550a25,25,0,0,1,25,25v25Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStorage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Storage.a65724eb.svg";
export { ForwardRef as ReactComponent };